import TesterApiOdoo from './TesterApiOdoo';

function App() {
  return (
    <div className="App">
      <TesterApiOdoo />
    </div>
  );
}

export default App;
